import { render, staticRenderFns } from "./StudyPDFVersionModal.vue?vue&type=template&id=61562824&scoped=true&"
import script from "./StudyPDFVersionModal.vue?vue&type=script&lang=js&"
export * from "./StudyPDFVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./StudyPDFVersionModal.vue?vue&type=style&index=0&id=61562824&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61562824",
  null
  
)

export default component.exports